import { FormattedMessage } from "react-intl";

export function ProcessingErrorMessage({ code }: { code?: string | null }) {
  switch (code) {
    case "unreadable_document":
      return (
        <FormattedMessage
          id="b466497a-1547-434a-9a69-da225650f954"
          defaultMessage="We couldn't read this file. Check that it opens correctly, then try again."
        />
      );
    case "enqueue_failed":
      return (
        <FormattedMessage
          id="293871d2-1331-43c8-ae77-466f2a868c45"
          defaultMessage="Processing could not be started. Try again now."
        />
      );
    case "temporary_processing_failure":
      return (
        <FormattedMessage
          id="983c3a88-6e78-4504-98da-35c068b94cb4"
          defaultMessage="A processing service was temporarily unavailable. Try again."
        />
      );
    default:
      return (
        <FormattedMessage
          id="a20c21fd-b02e-485a-b922-e636a58717d8"
          defaultMessage="We couldn't finish processing this source. Open it for details or try again."
        />
      );
  }
}
